import React, { PureComponent } from 'react'
import Box from '../../../Shared/Box'
import PropTypes from 'prop-types'
import './style.scss'
import { Col, Container, Row } from '../../../Shared/Grid'
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard/lib/Component'
import activityTrackingService from '../../../../services/activityTrackingService'
import PageHead from '../../../Shared/PageHead'
import { withTranslation } from 'react-i18next'
import DescriptionForReview from './DescriptionForReview'
import { submitFeedbackForDescriptionForReview } from '../../../../api'
import { ReactComponent as CopyIcon } from '../../../../assets/img/icons/copy-files.svg'
import { ReactComponent as XLogo } from '../../../../assets/img/icons/x-logo.svg'
import { descriptionForReviewShape } from './DescriptionForReview/shapes'
import history from '../../../../history'
import { propertyNavRoutes } from '../NavigationSidebar/NavigationHelper'

class OpenContentLink extends PureComponent {
  state = {
    copied: false,
  }
  copiedTimeout = null
  /** @type {AbortController} */
  abortController = null

  componentDidMount () {
    activityTrackingService.trackPageView('Open Content Link', {
      giataId: this.props.property.giataId,
    })
  }

  componentWillUnmount () {
    clearTimeout(this.copiedTimeout)
    this.abortController?.abort()
  }

  submitFeedback = (feedbackData) => {
    this.abortController?.abort()
    this.abortController = new AbortController()
    const { property, descriptionForReview } = this.props
    const { giataId } = property
    submitFeedbackForDescriptionForReview(
      giataId,
      descriptionForReview.propertyDescription.id,
      feedbackData,
      this.abortController
    ).catch(e => {
      console.error('Failed to submit feedback', e)
    })
  }

  postCopy = () => {
    this.setState({ copied: true })
    clearTimeout(this.copiedTimeout)
    this.copiedTimeout = setTimeout(() => this.setState({ copied: false }), 3000)
  }

  goToFactsheet = () => {
    history.push('/property/' + this.props.property.giataId + '/' + propertyNavRoutes.editProperty)
  }

  render () {
    const body = encodeURIComponent('This hotel is now available on GIATA Drive.')
    const subject = encodeURIComponent(this.props.property.name + ' ' + this.props.property.city.name + ' ' + this.props.property.country.name)
    const openContentLinkUrl = encodeURIComponent('https://giatadrive.com/' + this.props.property.giataId)

    const faceBookUrl = 'https://facebook.com/sharer/sharer.php?u=' + openContentLinkUrl
    const twitterUrl = 'https://x.com/intent/post/?url=' + openContentLinkUrl
    const mailHref = 'mailto:?subject=' + subject + '&body=' + body + ' ' + openContentLinkUrl
    const linkedInUrl = 'https://www.linkedin.com/shareArticle?mini=true&url=' + openContentLinkUrl
    const whatsAppUrl = 'https://api.whatsapp.com/send?text=' + openContentLinkUrl
    const { t, descriptionForReview, property } = this.props

    return (
      <div className={'page'}>
        <Box>
          <Container fluid gutterWidth={5} className={'open-content-link'}>
            <Row>
              <Col xs={12}>
                <PageHead
                  title={t('OPEN_CONTENT_LINK')}
                  subtitle="Share it with your business partners via email or social media."
                />
                <div className="share-link">
                  <a href={decodeURIComponent(openContentLinkUrl)} target="_blank" rel="noreferrer"
                     className="share-link__url">{decodeURIComponent(openContentLinkUrl)}
                  </a>
                  <ReactCopyToClipboard
                    onCopy={this.postCopy}
                    text={decodeURIComponent(openContentLinkUrl)}
                  >
                    <div className="share-link__copy-btn">
                      <CopyIcon/>
                      {this.state.copied ? 'Copied!' : 'Copy link'}
                    </div>
                  </ReactCopyToClipboard>
                  <div className="share-bar">
                    <a className="resp-sharing-button__link"
                       href={faceBookUrl}
                       target="_blank" rel="noopener noreferrer" aria-label="">
                      <div className="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small">
                        <div aria-hidden="true"
                             className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path
                              d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/>
                          </svg>
                        </div>
                      </div>
                    </a>
                    <a className="resp-sharing-button__link"
                       href={twitterUrl}
                       target="_blank" rel="noopener noreferrer" aria-label="">
                      <div className="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small">
                        <div aria-hidden="true"
                             className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                          <XLogo/>
                        </div>
                      </div>
                    </a>
                    <a className="resp-sharing-button__link"
                       href={mailHref}
                       target="_self" rel="noopener noreferrer" aria-label="">
                      <div className="resp-sharing-button resp-sharing-button--email resp-sharing-button--small">
                        <div aria-hidden="true"
                             className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path
                              d="M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"/>
                          </svg>
                        </div>
                      </div>
                    </a>
                    <a className="resp-sharing-button__link"
                       href={linkedInUrl}
                       target="_blank" rel="noopener noreferrer" aria-label="">
                      <div className="resp-sharing-button resp-sharing-button--linkedin resp-sharing-button--small">
                        <div aria-hidden="true"
                             className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path
                              d="M6.5 21.5h-5v-13h5v13zM4 6.5C2.5 6.5 1.5 5.3 1.5 4s1-2.4 2.5-2.4c1.6 0 2.5 1 2.6 2.5 0 1.4-1 2.5-2.6 2.5zm11.5 6c-1 0-2 1-2 2v7h-5v-13h5V10s1.6-1.5 4-1.5c3 0 5 2.2 5 6.3v6.7h-5v-7c0-1-1-2-2-2z"/>
                          </svg>
                        </div>
                      </div>
                    </a>
                    <a className="resp-sharing-button__link"
                       href={whatsAppUrl} target="_blank" rel="noopener noreferrer" aria-label="">
                      <div className="resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--small">
                        <div aria-hidden="true"
                             className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path
                              d="M20.1 3.9C17.9 1.7 15 .5 12 .5 5.8.5.7 5.6.7 11.9c0 2 .5 3.9 1.5 5.6L.6 23.4l6-1.6c1.6.9 3.5 1.3 5.4 1.3 6.3 0 11.4-5.1 11.4-11.4-.1-2.8-1.2-5.7-3.3-7.8zM12 21.4c-1.7 0-3.3-.5-4.8-1.3l-.4-.2-3.5 1 1-3.4L4 17c-1-1.5-1.4-3.2-1.4-5.1 0-5.2 4.2-9.4 9.4-9.4 2.5 0 4.9 1 6.7 2.8 1.8 1.8 2.8 4.2 2.8 6.7-.1 5.2-4.3 9.4-9.5 9.4zm5.1-7.1c-.3-.1-1.7-.9-1.9-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1s-1.2-.5-2.3-1.4c-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6s.3-.3.4-.5c.2-.1.3-.3.4-.5.1-.2 0-.4 0-.5C10 9 9.3 7.6 9 7c-.1-.4-.4-.3-.5-.3h-.6s-.4.1-.7.3c-.3.3-1 1-1 2.4s1 2.8 1.1 3c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.3.2-.7.2-1.2.2-1.3-.1-.3-.3-.4-.6-.5z"/>
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
            {
              descriptionForReview && <>
                <br/>
                <Row>
                  <div className="desc-for-review-notice">
                    <span className="desc-for-review-notice__text">
                      {t('openContentLink.descriptionForReview.header.subtitle')}
                    </span>
                  </div>
                </Row>
                <DescriptionForReview
                  title={property.name}
                  descriptionForReview={descriptionForReview}
                  onSubmitFeedback={this.submitFeedback}
                  onCheckFactsheet={this.goToFactsheet}
                />
                <br/>
                <br/>
              </>
            }
          </Container>
        </Box>
      </div>
    )
  }
}

OpenContentLink.propTypes = {
  property: PropTypes.shape({
    giataId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    city: PropTypes.shape({
      name: PropTypes.string
    }).isRequired,
    country: PropTypes.shape({
      name: PropTypes.string
    }).isRequired
  }).isRequired,
  descriptionForReview: descriptionForReviewShape,
}

export default withTranslation()(OpenContentLink)
